import Splide from '@splidejs/splide';
import Marquee3k from 'marquee3000';
import AOS from 'aos';
import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupMetaTagsPlugin from 'swup-meta-tags-plugin';

// import balanceText from './raggedlines.js';

const swup = new Swup({
  plugins: [new SwupBodyClassPlugin(), new SwupMetaTagsPlugin()]
}); 

let body = document.body;
let snake = document.querySelector('.sidebar_snake');

let site = {
  menu: 'closed',
  search: 'closed',
  snakePos: 0,
}

const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;


// Events
document.querySelector('.sidebar_burger').addEventListener("click", function(event) {
  triggerMenu(event);
  event.preventDefault();
});

document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  init();
  aosInit();
  menuLinksClicked();
  // balanceText();
});

// handleFormTags(event) {
//   event.preventDefault();
//   l('site.handleFormTags');
//   let clicked = $(this);
//   if(clicked.hasClass('active')) {
//     clicked.removeClass('active');
//     site.updateTags();
//   } else {
//     $(this).addClass('active');
//     site.updateTags();
//   }
// }

// updateTags() {
//   l('site.updateTags');
//   let summary = $('.form-tagsummary');
//   let input = $('input[name="tags"]');
//   let tagNumber = $('.form-tags a.active').length;
//   l(tagNumber);

//   if(tagNumber == 1) {
  
//     let tag = $('.form-tags a.active').data('tag');
//     summary.empty().append(tag);
//     input.val(tag);
  
//   } else if(tagNumber == 0) {
//     summary.empty();
//     input.val('');
//   } else {
//     let tags = '';
//     $('.form-tags a.active').each(function(){
//       tags += $(this).data('tag') + ', ';
//     });
    
//     summary.empty().append(tags)
//     input.val(tags);

//   }
//   // each(function() {
//   //   // l($())
//   // });
// }


function formSelects() {

  let dates = document.querySelectorAll('.form-dates a');
  let datesInput = document.querySelector('input[name="dates"]');
  dates.forEach(function (el) {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      let tag = el.getAttribute('data-tag') + ', ';
      if(el.classList.contains('active')) {
        el.classList.remove('active')
        datesInput.value = datesInput.value.replace(tag, '');
      } else {
        el.classList.add('active');
        datesInput.value = datesInput.value + tag;
      }
    });
  });

  let cats = document.querySelectorAll('.form-categories a');
  let catsInput = document.querySelector('input[name="categories"]');
  cats.forEach(function (el) {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      let tag = el.getAttribute('data-tag') + ', ';
      if(el.classList.contains('active')) {
        el.classList.remove('active');
        catsInput.value = catsInput.value.replace(tag, '');
      } else {
        el.classList.add('active');
        catsInput.value = catsInput.value + tag;
      }
    });
  });

  let submit = document.querySelector('.form_submit input[type=submit]');
  if(submit) {
    submit.addEventListener('click', function(event) {
      if(document.querySelector('input[type=file]').checkValidity()) {
        submit.classList.add('loading');
        submit.value = 'Loading...';
      }
    });
  }

}


function aosInit() {
  AOS.init({
    duration: 450,
    once: false,
  });
}

function registerFilterButtons() {
  let filterbtns = document.querySelectorAll('.filter_next');
  filterbtns.forEach(function (el) {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      scrollFilter(el);
    });
  });
}

function scrollFilter(el) {
  let list = el.previousElementSibling
  if(el.text == '>') {
    el.text = '<';
    list.scroll({
      top: 0,
      left: list.scrollWidth - list.clientWidth,
      behavior: 'smooth'
    });
  } else {
    el.text = '>';
    el.previousElementSibling.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}

window.onscroll = function() { scrollTrigger() };

swup.on('contentReplaced', function(){
  scroll(0,0);
  init();
});

function listenNavbar() {
  const el = document.querySelector('.navbar');
  const observer = new IntersectionObserver( 
    ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
    { threshold: [1] }
  );

  if(el) { observer.observe(el); }
}

// Functions
function l(m) { 
  console.log(m); 
}

function init() {
  l('👍');
  homeSnake();
  Marquee3k.init();
  startSliders();
  startAccordions();
  listenNavbar();
  highlightActive();
  focusSearch();
  lazyImages();
  registerFilterButtons();
  formSelects();
}

function menuLinksClicked() {
  if(isMobile) {
    let links = document.querySelectorAll('.sidebar a:not(.sidebar_burger), .container a');
    links.forEach(link => {
      link.addEventListener('click', el => {
        if(body.hasAttribute('data-menuopen')) {
          triggerMenu()
        } else {
          l('nothing');
        }
      });
    })
  }
}

function focusSearch() {
  l('focusSearch');
  if(window.location.pathname == '/search') {
    document.querySelector('#search input[type=search]').focus();
  }
}

function startAccordions() {
  document.querySelectorAll('.accordion_a').forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault();
      toggleAccordion(el);
    })
  });
}

function toggleAccordion(el) {

  let $parent = el.parentElement,
      $content = el.nextSibling.nextSibling,
      contentH = $content.querySelector('.accordion_inner').offsetHeight;
  l(contentH);
  
  if($parent.classList.contains('active')) {
    $parent.classList.remove('active');
    $content.style.height = 0 + 'px';
  } else {
    $parent.classList.add('active');
    $content.style.height = contentH + 'px';
  }
}

function triggerMenu() {
  if(site.menu == 'closed') {
    site.menu = 'open';
    body.setAttribute('data-menuopen', '');
  } else {
    site.menu = 'closed';
    body.removeAttribute('data-menuopen');
  }
}

function scrollTrigger() {

  if (document.body.scrollTop > 50 ||   document.documentElement.scrollTop > 50) {
    body.setAttribute('data-showsnake', '');
  } else {
    body.removeAttribute('data-showsnake');
  }

}

function highlightActive() {
  let btns = document.querySelectorAll('.sidebar_menu li a');
  btns.forEach(el => {
    el.addEventListener('click', btn => {
      [].forEach.call(btns, function(el) {
        el.classList.remove('active');
      });
      btn.target.classList.add('active');
    });
  });
  document.querySelector('.sidebar_search').addEventListener('click', btn => clearNav());
  document.querySelector('.sidebar_snake a').addEventListener('click', btn => clearNav());
}

function clearNav() {
  let btns = document.querySelectorAll('.sidebar_menu li a');
  [].forEach.call(btns, function(el) {
    el.classList.remove('active');
  }); 
}

function lazyImages() {
    l('lazyImages');
    var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
    if ("IntersectionObserver" in window) {
      let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            let lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.src;
            // lazyImage.srcset = lazyImage.dataset.srcset;
            lazyImage.classList.add("animate");
            lazyImageObserver.unobserve(lazyImage);
            
          }
        });
      });

      lazyImages.forEach(function (lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });
    }
}

// home snake variables
let colors = ['#07669A', '#EEBC00', '#D0B5A3', '#F07B33', '#E8B4B9', '#A1C527', '#08780C', '#C9AA67'],
colIndex = 0,
totalCols = colors.length - 1;

function homeSnake() {
  // on mouseenter change col
  document.querySelectorAll('.snake svg path').forEach(path => 
    path.addEventListener('mouseenter', el => {
      el.target.setAttribute('fill', colors[colIndex]);
      if(colIndex >= totalCols) { colIndex = 0; } else { colIndex++; }
    })
  );
}




function startSliders() {
  l('startSliders');
  if(document.querySelectorAll('.splide').length) { 

    let perPage = isMobile ? 1.5 : 3.5;
    let splide = new Splide( '.splide', {
      type: 'loop',
      focus  : 'left',
      perPage: perPage,
      // perMove: 1,
      arrows: true,
      pagination: false
    });

    splide.mount();
  }
  // HERO Slide  
  // document.querySelectorAll('.tnslider').forEach(el => {
    // tns({
    //   container: el,
    //   slideBy: 'page',
    //   autoplay: true,
    //   items: 3,
    //   autoplayTimeout: 4000,
    //   controls: false,
    //   speed: 500,
    //   navbar: false,
    //   autoHeight: true,
    //   mouseDrag: true, 
    //   swipeAngle: false,
    //   fixedWidth: 400,
    // });
  // });


}

